/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckoutSessionResponse
 */
export interface CheckoutSessionResponse {
    /**
     * 
     * @type {string}
     * @memberof CheckoutSessionResponse
     */
    sessionId: string;
}

export function CheckoutSessionResponseFromJSON(json: any): CheckoutSessionResponse {
    return CheckoutSessionResponseFromJSONTyped(json, false);
}

export function CheckoutSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckoutSessionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sessionId': json['session-id'],
    };
}

export function CheckoutSessionResponseToJSON(value?: CheckoutSessionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'session-id': value.sessionId,
    };
}


